<template>
  <div v-if="isVisible" class="nav">
    <ul>
      <li v-for="item in navItems" :key="item.name">
        <router-link :to="item.link" active-class="active-link">{{
          item.name
        }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    navItems: Array,
    isVisible: Boolean,
  },
};
</script>

<style>
@import "../assets/css/nav.css";
</style>
